'use strict';

let zIndexForPopup = 10;
let primarSvgRaknare;
let sekundarSvgRaknare;
let infoWindow = null;

const kartor = {
    ikonLokalPrimar: '/gui/img/pin-lokal-primar.svg',
    ikonLokalSekundar: '/gui/img/pin-lokal-sekundar.svg',
    ikonFastighetPrimar: '/gui/img/pin-fastighet-primar.svg',
    ikonFastighetSekundar: '/gui/img/pin-fastighet-sekundar.svg',
    ikonProjektPrimar: '/gui/img/pin-projekt-primar.svg',
    ikonProjektSekundar: '/gui/img/pin-projekt-sekundar.svg',
    zoomLevelForAttVisaAntal: 12,

    initieraKarta: function (initMap) {
        const apiKey = document.getElementById('mapsApiKey');
        if (apiKey) {

            if (typeof google === 'object' && typeof google.maps === 'object')  {
                initMap();

                var scrollpos = sessionStorage.getItem('scrollpos');
                if (scrollpos) {
                    let main = document.querySelector('main');
                    main.scrollTo(0, scrollpos);
                    sessionStorage.removeItem('scrollpos');
                }
            } else {
                $.ajax({
                    url: 'https://maps.googleapis.com/maps/api/js?key=' + apiKey.value + '&libraries=&v=beta',
                    dataType: 'script',
                    success: function() {

                        initMap();

                        var scrollpos = sessionStorage.getItem('scrollpos');
                        if (scrollpos) {
                            let main = document.querySelector('main');
                            main.scrollTo(0, scrollpos);
                            sessionStorage.removeItem('scrollpos');
                        }
                    },

                    async: true
                });

                window.google = {};
            }
        }
    },
    skapaKarta: function (element, latitud, longitud, overrideZoomFactor, overrideControlPosition, fullscreenMap) {
        const mapsMapId = document.getElementById('mapsMapId').value;
        const zoomFactorElement = document.getElementById('zoomFactor');
        let zoomFactor = 15;
        let controlPosition = google.maps.ControlPosition.RIGHT_BOTTOM;
        if (zoomFactorElement) {
            zoomFactor = zoomFactorElement.value;
        }

        let center = null;

        if (latitud && longitud) {
            center = new google.maps.LatLng(latitud, longitud);
        }

        if (overrideZoomFactor) {
            zoomFactor = overrideZoomFactor;
        }

        if (overrideControlPosition) {
            controlPosition = overrideControlPosition;
        }

        return new google.maps.Map(element, {
            zoom: parseFloat(zoomFactor),
            gestureHandling: 'cooperative',
            mapId: mapsMapId,
            streetViewControlOptions: {
                position: controlPosition
            },
            zoomControl: true,
            zoomControlOptions: {
                style: google.maps.ZoomControlStyle.SMALL,
                position: controlPosition

            },
            center: center,
            mapTypeControl: true,
            mapTypeControlOptions: {
                mapTypeIds: [
                    google.maps.MapTypeId.ROADMAP,
                    google.maps.MapTypeId.SATELLITE,
                    google.maps.MapTypeId.HYBRID
                ],
                style: fullscreenMap ? google.maps.MapTypeControlStyle.DROPDOWN_MENU : google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
                position: fullscreenMap ? google.maps.ControlPosition.TOP_CENTER : google.maps.ControlPosition.TOP_LEFT
            },
            fullscreenControl: fullscreenMap ? false : true,
            zIndex:1040
        });
    },
    marker: function (latitud, longitud, map, icon) {
        return new google.maps.Marker({
            position: new google.maps.LatLng(latitud, longitud),
            icon: {
                url: icon
            },
            map: map
        });
    },
    skapaPopupHtmlFranObjekt: function (objekt, iGrupp = false) {
        const cardInfo = objekt.querySelector('.card-body').outerHTML;
        const objektTyp = objekt.getAttribute('data-objekttyp');

        const slides = objekt.querySelectorAll('.slick-slide');
        let cssClass = objekt.classList[0];
        let slidesHtml = '';

        slides.forEach(function (slide) {
            slidesHtml += slide.outerHTML.replace('slick-current', '').replace('slick-active', '')
                .replace('slick-slide', '');
        });

        if (iGrupp) {
            cssClass += ' popup-i-grupp';
        }

        let popup = '<div class="' + cssClass + ' card-map-popup"><div class="card"><div class="card-rubrik">' + objektTyp + '</div><div class="sidhuvud-slideshow list-slideshow js-slideshow-popup">' + slidesHtml + '</div>' + cardInfo + '</div></div>';

        return popup;
    },
    skapaPopupHtmlFranLista: function (lista) {
        let popuper = '';
        lista.forEach(function(objekt) {
            popuper += kartor.skapaPopupHtmlFranObjekt(objekt, true);
        });
        let popup = '<div class="popup-grupp"><div class="popup-card-slideshow">' + popuper + '</div><div class="popup-grupp-navigation"><span class="grupp-current"> Visar <span class="current-index">1</span> av ' + lista.length +' lokaler</span></div>';

        return popup;
    },
    hanteraPopup: function (map, marker, popup) {
        google.maps.event.addListener(marker, 'click', (function (marker) {
            return function () {
                if (infoWindow) {
                    infoWindow.close();
                }
                infoWindow = new google.maps.InfoWindow();
                google.maps.event.addListener(infoWindow, 'domready', function () {
                    kartor.initSlideshowILokalPopup();
                });
                infoWindow.setContent(popup);
                infoWindow.open(map, marker);
                infoWindow.setZIndex(zIndexForPopup);
                zIndexForPopup++;
            }
        })(marker));
    },
    hanteraPopupGrupp: function (map, marker, popup) {
        google.maps.event.addListener(marker, 'click', (function (marker) {
            return function () {
                if (infoWindow) {
                    infoWindow.close();
                }
                infoWindow = new google.maps.InfoWindow();
                google.maps.event.addListener(infoWindow, 'domready', function () {
                    kartor.initSlideshowPopupGroup();
                });
                infoWindow.setContent(popup);
                infoWindow.open(map, marker);
                infoWindow.setZIndex(zIndexForPopup);
                zIndexForPopup++;
            }
        })(marker));
    },

    initSlideshowILokalPopup: function () {
        const popupSlideShows = document.querySelectorAll('.card-map-popup:not(.popup-i-grupp) .js-slideshow-popup:not(.slick-initialized)');
        af.initSlideshow(popupSlideShows);

        if (popupSlideShows.length > 0) {
            const videosInfo = popupSlideShows[0].querySelectorAll('video');
            media.spelaVideoVidKlick(videosInfo);
            af.loadImages(popupSlideShows[0].querySelectorAll('[data-bg-image-url]'));
        }
    },
    initSlideshowPopupGroup: function () {
        const popupGruppSlideShows = document.querySelectorAll('.popup-card-slideshow:not(.slick-initialized)');


        af.initSlideshowGrupp(popupGruppSlideShows);
        const popupSlideShows = document.querySelectorAll('.popup-card-slideshow .slick-slide[data-slick-index = "0"] .js-slideshow-popup:not(.slick-initialized)');
        af.initSlideshow(popupSlideShows);

        if (popupSlideShows.length > 0) {
            const videosInfo = popupSlideShows[0].querySelectorAll('video');
            media.spelaVideoVidKlick(videosInfo);
            af.loadImages(popupSlideShows[0].querySelectorAll('[data-bg-image-url]'));
        }

    },
    hamtaUnikaLokaler: function (lokaler) {
        var unikaLokaler = [];
        lokaler.forEach(function (item) {
            var isPresent = unikaLokaler.filter(function (elem) {
                return elem.dataset.latitud === item.dataset.latitud &&
                    elem.dataset.longitud === item.dataset.longitud;
            });
            if (isPresent.length === 0) {
                unikaLokaler.push(item);
            }
        });

        return unikaLokaler;
    },
    hamtaLokalerPaSammaAdress: function (lokaler, latitud, longitud) {
        var lokalerPaSammaAdress = [];
        lokaler.forEach(function (item) {
            if (item.dataset.latitud === latitud && item.dataset.longitud === longitud) {
                lokalerPaSammaAdress.push(item);
            }
        });

        return lokalerPaSammaAdress;
    },
    hamtaSvgRaknare: function () {
        if (!primarSvgRaknare) {
            fetch(kartor.ikonLokalPrimar.replace('.svg', '-raknare.svg'))
                .then(response => response.text())
                .then((data) => {
                    primarSvgRaknare = data;
                });
        }
        if (!sekundarSvgRaknare) {
            fetch(kartor.ikonLokalSekundar.replace('.svg', '-raknare.svg'))
                .then(response => response.text())
                .then((data) => {
                    sekundarSvgRaknare = data;
                });
        }
    },
    markeraLokaler: function (map, lokaler, markers, fitBounds, ikon, latitudPrimar, longitudPrimar) {
        var bounds = new google.maps.LatLngBounds();

        var unikaLokaler = kartor.hamtaUnikaLokaler(lokaler);

        unikaLokaler.forEach(lokal => {
            const latitud = lokal.dataset.latitud;
            const longitud = lokal.dataset.longitud;

            const lokalerPaSammaAdress =
                kartor.hamtaLokalerPaSammaAdress(lokaler, latitud, longitud);

            const arPopupGrupp = lokalerPaSammaAdress.length !== 1;
            const popup = arPopupGrupp
                ? kartor.skapaPopupHtmlFranLista(lokalerPaSammaAdress)
                : kartor.skapaPopupHtmlFranObjekt(lokal);

            if (latitud !== '' & longitud !== '') {
                let markerIkon = ikon;
                let svg;

                if (latitudPrimar &&
                    longitudPrimar &&
                    latitud === latitudPrimar &&
                    longitud === longitudPrimar) {
                    markerIkon = kartor.ikonLokalPrimar;
                }

                if (arPopupGrupp && map.getZoom() > kartor.zoomLevelForAttVisaAntal) {
                    let ikonMedRaknare = markerIkon === kartor.ikonLokalPrimar
                        ? primarSvgRaknare
                        : sekundarSvgRaknare;

                    if (ikonMedRaknare) {
                        svg = ikonMedRaknare.replace('{{ antal }}', lokalerPaSammaAdress.length);
                        markerIkon = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
                    }

                    let marker = kartor.marker(latitud, longitud, map, markerIkon);
                    markers.push(marker);

                    kartor.hanteraPopupGrupp(map, marker, popup);

                    if (fitBounds) {
                        bounds.extend(marker.position);
                    }


                } else {
                    let marker = kartor.marker(latitud, longitud, map, markerIkon);
                    markers.push(marker);

                    if (arPopupGrupp) {
                        kartor.hanteraPopupGrupp(map, marker, popup);
                    } else {
                        kartor.hanteraPopup(map, marker, popup);
                    }

                    if (fitBounds) {
                        bounds.extend(marker.position);
                    }
                }
            }
        });

        if (fitBounds) {
            try {
                map.fitBounds(bounds, { top: 100, right: 100, bottom: 50, left: 50 });
            } catch (e) {
                console.error('Error in map.fitBounds:', e);
            }
        }

        return markers;
    }
    
};

